import { apiServer } from '../settings'
import {getToken} from './token'

const getAllBots = (game, done) => {
	if (!game) return done('missing game')

	const headers = new Headers({'Authorization': 'Bearer ' + getToken()})

	const options = { method: 'GET', headers, mode: 'cors', cache: 'default' }

	const url = `${apiServer}/get-all-bots?game=${game}`

	fetch(url, options)
		.then(function(response) {
			return response.json()
		})
		.then(function(response) {
			if (response.success === false) return done(response.err)
			if (response.success === true) return done(null, response.result)
			if (!response.success) return done('response without success true|false')
		})
		.catch(error=> {
			return done(error.toString())
		})

}


export default getAllBots
